.textareaPaperWrapper {
  &:focus-within {
    box-shadow: 0px 0px 2px 2px var(--mantine-primary-color-filled);
  }
}

/* Dims the attachment chips + textarea (not the bottom action bar) while a send/upload is in
   flight, and makes them inert — the `readOnly` textarea already blocks typing, this just signals
   "busy" and belt-and-suspenders blocks stray clicks. */
.composeBusyContent {
  opacity: 0.5;
  pointer-events: none;
  transition: opacity 150ms ease;
}
